import React from 'react';
import MenuContent from '../MenuContent';
import NavList from '../NavList';

const SpecialsBlock = ({ specials }) => {
  return (
    <MenuContent className="specials-block row">
      <NavList className="lg-12 md-12 top-menu">
        <h4 className="d-sm-none">
          <a href={specials.heading.link}>{specials.heading.label}</a>
        </h4>
        <ul className="col-lg-2">
          {
            specials.links.map(item => (
              <li key={item.link}>
                <a href={item.link}>{item.label}</a>
              </li>
            ))
          }
        </ul>
      </NavList>
      <a className="specials-offer sm-12 util-txt-center" href={specials.homePage}>
        <img
          className="img-specials util-img-responsive d-inline-block"
          src="//cdn.sandals.com/beaches/v12/images/globals/navigation/dropdown-no-worry-v2.png"
          alt="Specials' Promotion"
        />
        <span className="d-block offer-details">
          View Offer Details <i className="icon-arrow" />
        </span>
      </a>
    </MenuContent>
  );
};

export default SpecialsBlock;

SpecialsBlock.defaultProps = {
  specials: {},
};



// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/SpecialsBlock.js